import "../../src/localization/arabic";
import "../../src/localization/basque";
import "../../src/localization/bulgarian";
import "../../src/localization/burmese";
import "../../src/localization/catalan";
import "../../src/localization/croatian";
import "../../src/localization/czech";
import "../../src/localization/danish";
import "../../src/localization/dutch";
import "../../src/localization/nl-BE";
import "../../src/localization/estonian";
import "../../src/localization/finnish";
import "../../src/localization/french";
import "../../src/localization/georgian";
import "../../src/localization/german";
import "../../src/localization/greek";
import "../../src/localization/hebrew";
import "../../src/localization/hindi";
import "../../src/localization/hungarian";
import "../../src/localization/icelandic";
import "../../src/localization/indonesian";
import "../../src/localization/italian";
import "../../src/localization/japanese";
import "../../src/localization/kazakh";
import "../../src/localization/korean";
import "../../src/localization/latvian";
import "../../src/localization/lithuanian";
import "../../src/localization/macedonian";
import "../../src/localization/malay";
import "../../src/localization/norwegian";
import "../../src/localization/persian";
import "../../src/localization/polish";
import "../../src/localization/portuguese";
import "../../src/localization/portuguese-br";
import "../../src/localization/romanian";
import "../../src/localization/russian";
import "../../src/localization/serbian";
import "../../src/localization/simplified-chinese";
import "../../src/localization/slovak";
import "../../src/localization/spanish";
import "../../src/localization/swahili";
import "../../src/localization/swedish";
import "../../src/localization/tajik";
import "../../src/localization/thai";
import "../../src/localization/traditional-chinese";
import "../../src/localization/turkish";
import "../../src/localization/ukrainian";
import "../../src/localization/vietnamese";
import "../../src/localization/welsh";
import "../../src/localization/telugu";
import "../../src/localization/philippines";
import "../../src/localization/slovenian";